<template>
	<div class="flex py-3xl flex-col bg-white px-3xl lg:px-none">
		<div class="flex py-xl items-center">
			<div class="flex flex-col justify-between items-center w-[30px] h-[32px]">
				<div class="w-3xl h-7xl rounded-medium bg-[#A3A3A3]" />
			</div>
		</div>
		<div class="flex py-md">
			<div class="flex items-center gap-xl flex-1">
				<div
					class="flex size-[48px] p-xxs items-center justify-center aspect-square rounded-xl bg-gray-100"
				/>
				<div class="flex flex-col gap-xxs flex-1">
					<div class="flex h-7xl flex-col justify-between opacity-[0.2]">
						<div class="w-[132px] h-3xl rounded-medium bg-[#424242]" />
					</div>
					<div class="flex h-3xl flex-col justify-between opacity-[0.2]">
						<div class="w-[48px] h-xl bg-[#737373]" />
					</div>
				</div>
			</div>
		</div>
		<div class="flex py-md">
			<div class="flex items-center gap-xl flex-1">
				<div
					class="flex size-[48px] p-xxs items-center justify-center aspect-square rounded-xl bg-gray-100"
				/>
				<div class="flex flex-col gap-xxs flex-1">
					<div class="flex h-7xl flex-col justify-between opacity-[0.2]">
						<div class="w-[82px] h-3xl rounded-medium bg-[#424242]" />
					</div>
					<div class="flex h-3xl flex-col justify-between opacity-[0.2]">
						<div class="w-[50px] h-xl bg-[#737373]" />
					</div>
				</div>
			</div>
		</div>
		<div class="flex py-md">
			<div class="flex items-center gap-xl flex-1">
				<div
					class="flex size-[48px] p-xxs items-center justify-center aspect-square rounded-xl bg-gray-100"
				/>
				<div class="flex flex-col gap-xxs flex-1">
					<div class="flex h-7xl flex-col justify-between opacity-[0.2]">
						<div class="w-[132px] h-3xl rounded-medium bg-[#424242]" />
					</div>
					<div class="flex h-3xl flex-col justify-between opacity-[0.2]">
						<div class="w-[48px] h-xl bg-[#737373]" />
					</div>
				</div>
			</div>
		</div>
		<div class="flex py-md">
			<div class="flex items-center gap-xl flex-1">
				<div
					class="flex size-[48px] p-xxs items-center justify-center aspect-square rounded-xl bg-gray-100"
				/>
				<div class="flex flex-col gap-xxs flex-1">
					<div class="flex h-7xl flex-col justify-between opacity-[0.2]">
						<div class="w-[82px] h-3xl rounded-medium bg-[#424242]" />
					</div>
					<div class="flex h-3xl flex-col justify-between opacity-[0.2]">
						<div class="w-[50px] h-xl bg-[#737373]" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
